import { Directive, ElementRef, Input, HostListener, ComponentRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { TooltipContentComponent } from '@lib-ui/lib/composite/custom-string-tooltip/custom-string-tooltip.component';


@Directive({
  standalone: false,
  selector: '[stringingCustomTooltip]'
})
export class StringingTooltipDirective {
  @Input('stringingCustomTooltip') tooltipData: any;
  private tooltipRef: ComponentRef<TooltipContentComponent> | null = null;

  constructor(
    private el: ElementRef,
    private vcr: ViewContainerRef,
    private resolver: ComponentFactoryResolver
  ) {}

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltipRef) {
      const factory = this.resolver.resolveComponentFactory(TooltipContentComponent);
      this.tooltipRef = this.vcr.createComponent(factory);
      this.tooltipRef.instance.data = this.tooltipData;

      const rect = this.el.nativeElement.getBoundingClientRect();
      const tooltipWidth = this.tooltipRef.location.nativeElement.offsetWidth;

      this.tooltipRef.instance.left = rect.left + rect.width / 2 - tooltipWidth / 2 + -85 + 'px'; // center horizontally
      this.tooltipRef.instance.top = rect.bottom + 'px'; // position just below
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltipRef) {
      this.tooltipRef.destroy();
      this.tooltipRef = null;
    }
  }
}
